module.exports = __webpack_public_path__ + "img/duck-model.04abc9dd.png";